import React, { useEffect, useState } from "react";
import fnc from "../mymod/commFunction";
import fncSql from "../mymod/commFunctionSql";
import { useNavigate } from "react-router-dom";
import './Assess_all_testNmApp.scss';
import { useDispatch, useSelector } from "react-redux";
import * as S from '../scss/theme';
import  HongButton from '../comm/HongButton';
// import HongButton from '@mui/material/Button';
import imgReport from '../images/svg/report.svg';
import imgCheckList from '../images/svg/checklist.svg';
import imgLink from '../images/svg/link.svg';
import HeaderTitle from "../comm/HeaderTitle";
import Assess_all_checkList from "./Assess_all_checkList";
import Assess_etc_checkList_result from "../page_assessment_ect/Assess_etc_checkList_result";
import Assess_book_checkList_result from "../page_assessment_ect/Assess_book_checkList_result";
import { setSelectedTestCode, setSelectedStCode } from "../reduxToolkit/reduxIgong";

const Assess_all_testNmApp = () => {
    // const {stCode, userName, userKind2} = useSelector((state) => state.reduxIgong.userInfo);
    const svrUrl = process.env.REACT_APP_SERVER_URL;
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const selectedStCode = useSelector((state) => state.reduxIgong.selectedStCode);
    const isStudent = useSelector((state) => state.reduxIgong.isStudent);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isRefresh, setIsRefresh] = useState(false);

    const [selectedSno, setSelectedSno] = useState(null);
    const [isModal_result, setIsModal_result] = useState(false);
    const [isModal_result_ect_study, setIsModal_result_ect_study] = useState(false);
    const [isModal_result_ect_book, setIsModal_result_ect_book] = useState(false);

    

    const [list, setList] = useState([]);
    const [title, setTitle] = useState('');
    const [testCode, setTestCode] = useState(null);
    const [testDate, setTestDate] = useState(null);

    useEffect(() => {
        fncSelect_list(selectedUserInfo.stCode);
        setTitle(`${selectedUserInfo.userName}`);
    }, [isRefresh]);
    
  
  function fncSelect_list(stCode) {
    
    fnc.sendAxios('/igonAssess_momTecRoutes/select/testNm', { stCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const newList = getRecords(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];  
        const testDate = res[i]["testDate"];
        const parentCode = res[i]["parentCode"];
        const stCode = res[i]["stCode"];
        const userName = res[i]["userName"];
        const userKind = res[i]["userKind"];
        const cntA = res[i]["cntA"];
        const cntB = res[i]["cntB"];
        const cntE = res[i]["cntE"];
        const cntF = res[i]["cntF"];
        const testCode = res[i]["testCode"];
        let sDate = res[i]["sDate"];
        const etcUseyn = res[i]["etcUseyn"];
        const bookUseyn = res[i]["bookUseyn"];
        const markingCnt = res[i]["markingCnt"];
        sDate = fnc.formatDate2(sDate);    
        records.push({ sno, testDate, parentCode, stCode, userName, userKind, cntA, cntB, cntE, cntF, testCode, 
          sDate, etcUseyn, bookUseyn, markingCnt });
    }
    return records;
  }

    
  
  function onClickTr( item, index) {

  }



  function onClickCheckList(item) {
    fncSql.getUserInfo(dispatch, item.stCode, () => {
      setTestCode(item.testCode);
      setIsModal_result(true);
    });

  }
  

  function onClickReport(item) {
    fncSql.getUserInfo(dispatch, item.stCode, () => {
      dispatch(setSelectedTestCode(item.testCode));
      navigate('/iongChartApp');
    });

  }
  

  
  // function fncGetInfo(stCode, callback) {   
  //   fnc.sendAxios('/igongLogin_allRoutes/select/usrInfo', { stCode }, (res) => {
  //     if (res && Array.isArray(res)) {   
  //       dispatch(setSelectedUserInfo(res[0]));
  //       callback();
  //     } else {
  //       alert('검색에 실패했습니다.');
  //     }
  //   });
  // }

  function onClickCheckList_basic(item) {
      dispatch(setSelectedStCode(item.stCode));
      dispatch(setSelectedTestCode(item.testCode));
      navigate('/assess/all/marking_stu');
  }

  function onClickCheckList_studyAbility(item) {

      dispatch(setSelectedStCode(item.stCode));
      dispatch(setSelectedTestCode(item.testCode));
      navigate('/assess_etc_app');
  }

  function onClickCheckList_studyAbility_result(item) {
      // dispatch(setSelectedStCode(item.stCode));
      // navigate('/assess_etc_checkList_nm');
        setTestCode(item.testCode);
        setTestDate(item.testDate);
        setIsModal_result_ect_study(true);
  }

  function onClickCheckList_readingAbility(item) {
      dispatch(setSelectedStCode(item.stCode));
      dispatch(setSelectedTestCode(item.testCode));
      navigate('/assess_book_app');
  }

  function onClickCheckList_readingAbility_result(item) {
      // dispatch(setSelectedStCode(item.stCode));
      // navigate('/assess_book_checkList_nm');
      // dispatch(setSelectedTestCode(item.testCode));
      setTestCode(item.testCode);
      setTestDate(item.testDate);
      setIsModal_result_ect_book(true);
  }

  function onMakeTest() {
    
    fncInsertMakeTest();

  }

  function onClickCoaching() {

    navigate('/videoEdu_stu');
    
  }

  
      function fncInsertMakeTest() {
    
          const testDate = fnc.fncDate();
          const parentCode = selectedUserInfo.orgCode;
          const userKind = selectedUserInfo.userKind;
          const stCode = selectedUserInfo.stCode;
          const testCode = fnc.fncSirialNum('AT');

          const rtn = window.confirm(`${testDate}의 진단지를 생성하시겠습니까?`);
          if (!rtn) return;
                           
          fncInsert_marking_score(testDate, parentCode, stCode, userKind, testCode);
  
  
  
          function fncInsert_marking_score(testDate, parentCode, stCode, userKind, testCode) {
  
              fnc.sendAxios('/igonAssess_momTecRoutes/insert/assess_makeTest', { 
                  testDate, parentCode, stCode, userKind, testCode }, (res) => {
                    if (res) {
                      if (res.success === 'exist') {
                          alert(`${testDate}에 생성한 진단지가 이미 존재합니다.`);
                      } else if (res.success === true) {
                          // alert('완료되었습니다.');
                          setIsRefresh(!isRefresh);
                      
                      }
                    } else {
                      alert('저장에 실패했습니다.');
                    }
              });
          }
              
      }


      
        function onClickLink(item) {
            // const stCode = selectedUserInfo.stCode;
            // const userKind = selectedUserInfo.userKind;

            const stCode = item.stCode;
            const userKind = item.userKind;
            const testCode = item.testCode;

            let link;
            fnc.sendAxios('/igongAssess_linkRoutes/gen-link', { svrUrl, stCode, userKind, testCode }, (res) => {
              if (res) { 
                link = res.link;
                navigator.clipboard.writeText(link)
                .then(() => {
                  alert('진단평가 링크가 클립보드에 복사되었습니다!');
                })
                .catch(err => {
                  alert('클립보드 복사에 실패했습니다.');
                  console.error('Copy error:', err);
                });
        
            } else {
              alert('링크 생성에 실패했습니다.');
            }
          });
        }

        function onClickLink_total() {//testNmApp전체 (나중에 삭제할 수도)

          const stCode = selectedUserInfo.stCode;
          const userKind = selectedUserInfo.userKind;
      
          let link;
          fnc.sendAxios('/igongAssess_linkRoutes/gen-link_total', { svrUrl, stCode, userKind }, (res) => {
            if (res) { 
              link = res.link;
              navigator.clipboard.writeText(link)
              .then(() => {
                alert('진단평가 링크가 클립보드에 복사되었습니다!');
              })
              .catch(err => {
                alert('클립보드 복사에 실패했습니다.');
                console.error('Copy error:', err);
              });
      
          } else {
            alert('링크 생성에 실패했습니다.');
          }
        });

        }

    //==================================================================================
    return (
        <S.Section>
        <HeaderTitle  title={title + '의 진단 리스트'} direction={1} onBackClick={() => navigate(-1)} />
           
        <div className="Assess_all_testNmApp">
        <section className='sec-main'>
            <title></title>
                    <table className="table-hong table-main">
                    <thead>
                        <tr>
                        <th>No</th>
                        <th>진단일자</th>
                        <th>이름</th>
                        {/* <th>A</th>     
                        <th>B</th>
                        <th>E</th>
                        <th>F</th>  */}
                        <th>코칭진단</th>
                        <th>코칭진단</th>
                        <th>공부력</th>
                        <th>공부력</th>
                        <th>독서력</th>
                        <th>독서력</th>
                        <th>REPORT</th>
                        <th>링크</th>
                        {/* <th>맞춤코칭</th> */}
                        </tr>
                    </thead>

                    <tbody>
                        {list && list.map((item, index) => (
        
                            <tr key={index} onClick={() => onClickTr(item, index)}
                                className={selectedSno === item.sno ? 'selected' : ''}>  
                                <td>{index+1}</td>
                                <td>{item.testDate}</td>
                                <td>{item.userName}</td>
                                {/* <td>{item.cntA}</td>  
                                <td>{item.cntB}</td>
                                <td>{item.cntE}</td>
                                <td>{item.cntF}</td> */}

                                 {/* 기본 진단 */}
                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-red"  
                                        onClick={() => onClickCheckList_basic(item)}
                                        disabled={item.markingCnt > 0}
                                    >
                                     {item.markingCnt > 0 ? '완료' : '진단'}
                                    </HongButton>
                                </td>


                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-white"  
                                        onClick={() => onClickCheckList(item)}  
                                        disabled={item.markingCnt == 0}
                                    >
                                      결과
                                    </HongButton>
                                </td>

                                {/* 공부력 진단 */}
                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-green"  
                                        onClick={() => onClickCheckList_studyAbility(item)}
                                        disabled={item.etcUseyn === 'Y'}
                                    >
                                       {item.etcUseyn === 'Y' ? '완료' : '진단'}
                                    </HongButton>
                                </td>

                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-white"  
                                        onClick={() => onClickCheckList_studyAbility_result(item)}
                                        disabled={item.etcUseyn !== 'Y'}
                                    >
                                      결과
                                    </HongButton>
                                </td>

                                {/* 독서력 진단 */}
                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-blue"  
                                        onClick={() => onClickCheckList_readingAbility(item)}
                                        disabled={item.bookUseyn === 'Y'}
                                    >
                                     {item.bookUseyn === 'Y' ? '완료' : '진단'}
                                    </HongButton>
                                </td>

                                <td>
                                    <HongButton 
                                        className="btnReport h-btn-white"  
                                        onClick={() => onClickCheckList_readingAbility_result(item)}
                                        disabled={item.bookUseyn !== 'Y'}
                                    >
                                      결과
                                    </HongButton>
                                </td>

                                <td>
                                    <HongButton 
                                        className="btnReport"  
                                        onClick={() => onClickReport(item)}
                                        startIcon={<img src={imgReport} alt="Report" />}
                                    >
                                    </HongButton>
                                </td>

                               <td>
                                    <HongButton 
                                        className="btnReport"  
                                        onClick={() => onClickLink(item)}
                                        startIcon={<img src={imgLink} alt="링크" />}
                                    >
                                    </HongButton>
                                </td>
                            </tr>
                        ))}
                    
                        </tbody>

                    </table>

                </section> 

                <div className="box-menu">
                  <HongButton  className=" btn h-btn-gray" onClick={() => setIsRefresh(!isRefresh)} >새로고침</HongButton>
                  {!isStudent && <HongButton  className=" btn h-btn-sky" onClick={() => onMakeTest()} >진단지 생성</HongButton> }
                
                  {/* {!isStudent && <HongButton  className=" btn h-btn-red" onClick={onClickLink_total} >링크복사 전체</HongButton> } */}
                </div>

                </div>

                {isModal_result && (
                    <S.Modal>
                        <HeaderTitle  title={title + '의 기본 진단 결과'} direction={1} onBackClick={() => setIsModal_result(false)} />
                        <section className="">
                                <Assess_all_checkList testCode={testCode} stCode={selectedStCode}/>
                        </section>              
                    </S.Modal>
                 )}

                  {isModal_result_ect_study && (
                    <S.Modal_pc>
                        <HeaderTitle  title={title + '의 공부력 진단 결과'} direction={1} onBackClick={() => setIsModal_result_ect_study(false)} />
                        <section className="">
                                <Assess_etc_checkList_result 
                                testCode={testCode} 
                                stCode={selectedUserInfo.stCode}
                                testDate={testDate}/>
                        </section>              
                    </S.Modal_pc>
                 )}


                  {isModal_result_ect_book && (
                        <S.Modal_pc>
                            <HeaderTitle  title={title + '의 독서력 진단 결과'} direction={1} onBackClick={() => setIsModal_result_ect_book(false)} />
                            <section className="">
                                    <Assess_book_checkList_result 
                                    testCode={testCode} 
                                    stCode={selectedUserInfo.stCode} 
                                    testDate={testDate}/>
                            </section>              
                        </S.Modal_pc>
                  )}

                 

        </S.Section>
    );
};

export default Assess_all_testNmApp;
